import React, { useEffect, useState } from 'react';

import { Redirect, Route, useLocation } from 'react-router-dom';

import { access } from './GuardedRoute';
import useBlocRef from '../../utils/useBlocRef.hook';

export default ({ component: Component, allowAuth, allow = true, ...others }) => {
  const appBlocRef = useBlocRef('appBloc');
  const appBloc = appBlocRef.current;
  const location = useLocation();
  const [auth, setAuth] = useState(appBloc.auth$.getValue());
  const [userDetails] = useState(appBloc.userDetails$.getValue());
  const [requestedOrder] = useState(appBloc.requestedOrder$.getValue());
  const [notPaidCases, setNotPaidCases] = useState(appBloc.notPaidCases$.getValue());

  useEffect(() => {
    const sub = appBloc.auth$.subscribe(setAuth);
    const notPaidCasesSub = appBloc.notPaidCases$.subscribe(setNotPaidCases);

    return () => {
      sub.unsubscribe();
      notPaidCasesSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let destination = '';
  if (auth && !allowAuth) {
    destination = access[auth.role].defaultRoute;

    if (auth.role === 'patient') {
      const shouldOpenPatientDashboard =
        !auth?.workspace?.isMediphanyWorkspace || requestedOrder || ['paid', 'complete'].includes(userDetails?.firstOrderStatus || auth?.firstOrderStatus);
      if (shouldOpenPatientDashboard) destination = '/patient-dashboard';

      const shouldOpenPaymentPage = !shouldOpenPatientDashboard && notPaidCases?.length > 0;
      if (shouldOpenPaymentPage) destination = '/package-plans';
    }

    if (location.search.includes('redirect')) {
      const query = new URLSearchParams(location.search);
      destination = query.get('redirect');
    }
  }

  if (!allow) {
    destination = '/login';
  }

  return (
    <Route
      {...others}
      render={(props) => {
        if (!allow) {
          return <Redirect to={destination} />;
        }

        if (!auth || allowAuth) {
          return <Component {...props} />;
        }

        return <Redirect to={destination} />;
      }}
    />
  );
};
